import React from 'react';
import PropTypes from 'prop-types';
import { isEmpty } from 'lodash-es';
/* Utils */
import { getSortedFeatures } from 'client/site-modules/shared/utils/private-party/features-and-specs';
/* Constants */
import { FEATURES } from 'client/site-modules/shared/constants/inventory/features-and-specs';
/* Components */
import { FeaturesModalView } from 'site-modules/inventory/components/features-modal-view/features-modal-view';
import { InventoryEntities } from 'client/data/models/inventory';

export function FeaturesModal({
  vinData = {},
  features = {},
  isModalOpen = false,
  toggleModal = null,
  options = null,
  isMobile = false,
  defaultDisplay = FEATURES,
}) {
  const featuresToDisplay = getSortedFeatures(features);
  const showInstalledUpgrades = !!options?.length;
  const hideFeatures = !showInstalledUpgrades && isEmpty(featuresToDisplay);
  const showToggleBtns = !hideFeatures && showInstalledUpgrades;

  return (
    <FeaturesModalView
      vinData={vinData}
      isModalOpen={isModalOpen}
      toggleModal={toggleModal}
      isMobile={isMobile}
      defaultDisplay={defaultDisplay}
      orderedOptions={options}
      featuresToDisplay={featuresToDisplay}
      showToggleBtns={showToggleBtns}
      hideFeatures={hideFeatures}
    />
  );
}

FeaturesModal.propTypes = {
  vinData: InventoryEntities.InventoryVin,
  features: PropTypes.shape({}),
  isModalOpen: PropTypes.bool,
  toggleModal: PropTypes.func,
  options: PropTypes.arrayOf(PropTypes.shape({})),
  isMobile: PropTypes.bool,
  defaultDisplay: PropTypes.string,
};
